import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

export interface ICallSobTrendsPartnerSearchParams {
  partnerId?: string
  searchStr?: string
}

export const callSobTrendsPartnerSearch = async ({
  partnerId,
  searchStr,
}: ICallSobTrendsPartnerSearchParams) => {
  const url = proxy(`/webservice/197/sp/v4/spJBPSOBTrendsPartnerSearch/call`)

  if (partnerId || searchStr) {
    const payload = {
      'p.PartnerId': partnerId || null,
      'p.SearchStr': searchStr || null,
    }
    const {
      app: { ownerId },
    } = appGetState()

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      return response.Data
    } catch (e) {
      Logger.error(e)
      return []
    }
  }

  return []
}
